import React, { useState, useEffect } from 'react';
import { AppBar, makeStyles, Menu, MenuItem, Button, } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { toast } from 'react-toastify';
import WorkstationNotificationsDrawer from '../Workstation/WorkstationNotificationsDrawer';
import SelectedWorkstation from '../Workstation/SelectedWorkstation';
import SelectedRecyclingWorkstation from '../Workstation/SelectedRecyclingWorkstation';
import { productionOrderStates as state } from '../../Config/productionOrderStates';
import { languageIds, Line14, Line15, Line16, Line17, Line18, LowerScissorLine14, LowerScissorLine15, LowerScissorLine16, LowerScissorLine17, LowerScissorLine18, UpperScissorLine14, UpperScissorLine15, UpperScissorLine16, UpperScissorLine17, UpperScissorLine18, Breaker1 } from '../../Config/constants';
import { dataService } from '../../Services/data.service';
import { useHistory, useLocation } from 'react-router-dom';
import { machineScissorZone, UpperScissorLine11, UpperScissorLine12, LowerScissorLine11, LowerScissorLine12, Line11, Line12 } from '../../Config/constants';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { connect } from 'react-redux';
import BreakDownDetectedDialog from './Dialogs/BreakDownDetectedDialog';
import ReportProblemDialog from './Dialogs/ReportProblemDialog';
import { scissorTypes, scissorStates } from '../../Config/scissorStates';
import { Bell, User } from 'lucide-react';
// import session from 'redux-persist/lib/storage/session';

export const HeaderBar = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [zones, setZones] = useState([]);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [reportProblemDialogOpen, setReportProblemDialogOpen] = useState(false);
  const [notificationSubmissionLoading, setNotificationSubmissionLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const classes = useStyles();
  const { t } = useTranslation();
  const appSettings = props.appSettings;

  let history = useHistory();
  let historyLocation = useLocation();

  useEffect(() => {
    const newNotificationsConnection = new HubConnectionBuilder()
      .withUrl(appSettings.IPB_INTERFACE_NOTIFICATIONS_HUB_URL)
      .withAutomaticReconnect()
      .build();
    newNotificationsConnection.on('ReceiveMessage', notificationsData => {
      console.log('Notifications data received: ', notificationsData);
      props.actions.incrementCounter();
    });
    newNotificationsConnection.start().then(() => {
      console.log('Notifications connected!');
    })
      .catch(e => console.log('Notifications connection failed: ', e));
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    dataService.getLatestNotifications(languageIds.DUTCH).then(logs => {
      let filteredLogs = [];
      if (props.workstation.activeWorkstations.length > 0) {
        if (props.workstation.activeWorkstations.some(x => x.id === Line11)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line11));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine11));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine11));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line12)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line12));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine12));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine12));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line14)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line14));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine14));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine14));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line15)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line15));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine15));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine15));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line16)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line16));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine16));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine16));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line17)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line17));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine17));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine17));
        }
        if (props.workstation.activeWorkstations.some(x => x.id === Line18)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Line18));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === UpperScissorLine18));
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === LowerScissorLine18));
        }
      }

      if (props.workstation.activeRecyclingWorkstations && props.workstation.activeRecyclingWorkstations.length > 0) {
        if (props.workstation.activeRecyclingWorkstations.some(x => x.id === Breaker1)) {
          filteredLogs = filteredLogs.concat(logs.filter(x => x.machineId === Breaker1));
        }
      }

      if (props.user.userInfo && props.user.isAdministrator) {
        filteredLogs = logs
      }

      logs = filteredLogs.sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn));
      setNotifications(logs);
    }
    ).catch((error) => { toast.error(error, { position: "top-center" }) });

    dataService.getMachinesByMachineType(machineScissorZone).then(scissorZones => {
      setZones(scissorZones);
    }).catch((error) => { toast.error(error, { position: "top-center" }) });

  }, [props.workstation.activeWorkstations, props.workstation.activeRecyclingWorkstations, props.notification.counter]);


  const logout = () => {
    history.push('/logout');
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openNotificationsDrawer = (open) => {
    if (!open) {
      props.actions.setCounter(0);
    }

    setNotificationDrawerOpen(open);
  }

  const openReportProblemDialog = () => {
    openNotificationsDrawer(false);
    setReportProblemDialogOpen(true);
  }

  const submitProblemNotification = (problemDescription) => {
    setNotificationSubmissionLoading(true);
    let tempSelectedWorkstationId = null;
    let tempSelectedWorkstationCode = null;

    if (props.nav.showActiveLines) {
      tempSelectedWorkstationId = props.workstation.selectedWorkstation;
    } else if (props.nav.showActiveRecyclingLines) {
      tempSelectedWorkstationId = props.workstation.selectedRecyclingWorkstationId;
    } else if (props.nav.showActiveCarpentryLines) {
      tempSelectedWorkstationId = props.workstation.selectedCarpentryWorkstationId;
    }

    if (props.nav.showActiveLines) {
      tempSelectedWorkstationCode = props.workstation.activeWorkstations.find(x => x.id === tempSelectedWorkstationId).code || null;
    } else if (props.nav.showActiveRecyclingLines) {
      tempSelectedWorkstationCode = props.workstation.activeRecyclingWorkstations.find(x => x.id === tempSelectedWorkstationId).code || null;
    }



    // Parameters to pass: notificationTypeId: any, barcode: any, machineId: any, machineCode: any, sampleSequence: any, productionOrderRef: any, sampleId: any, sampleCode: any, systemMessageId: any, message: any
    dataService.saveNotification(0, null, tempSelectedWorkstationId, tempSelectedWorkstationCode, null, null, null, null, 0, problemDescription).then(() => {
      toast.success(t("Problem reported"), { position: "top-center" });
      setReportProblemDialogOpen(false);
      setNotificationSubmissionLoading(false);
    }).catch((error) => { toast.error(error, { position: "top-center" }) });
  }

  function machineDataChanged(machineData) {
    let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();

    let tempScissorStatusses = [];
    props.workstationState.workstationsWithScissorStatusInfo.find(x => x.code === String(machineData.lineNumber)).scissorStatuses.map(x => { return tempScissorStatusses.push({ ...x }) });

    if (machineData.plannedStop && machineData.stopped) {
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.PLANNEDSTOP;
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#4654FB";
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#4654FB1A";

      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.PLANNEDSTOP;
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#4654FB";
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#4654FB1A";
    }
    else if (machineData.stopped) {
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.UNPLANNEDSTOP
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#D84949"
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#D849491A"

      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.UNPLANNEDSTOP;
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#D84949";
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#D849491A";
    }
    else {
      if (machineData.lowerScrap) {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.SCRAP;
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#F59127";
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#F591271A";
      }
      else {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.PRODUCTION;
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#5CC958";
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#5CC9581A";
      }
      if (machineData.upperScrap) {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.SCRAP;
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#F59127";
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#F591271A";
      }
      else {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.PRODUCTION;
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#5CC958";
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#5CC9581A";
      }
    }

    if (JSON.stringify(props.workstationState.workstationsWithScissorStatusInfo.find(x => x.code === String(machineData.lineNumber)).scissorStatuses) !== JSON.stringify(tempScissorStatusses)) {
      tempMachineScissorStates.find(x => x.code === String(machineData.lineNumber)).scissorStatuses = tempScissorStatusses;
      props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates);
    }
  }

  const selectLine = (line, orderId, orderLineId) => {

    let qualityCheckPageSwitch = historyLocation.pathname.includes("/qualitychecks/");

    dataService.getProductionOrdersByMachine(line).then(orders => {

      if (!qualityCheckPageSwitch) {
        props.actions.setSelectedWorkstation(line);
      }
      if (historyLocation.pathname.includes("/order/") || historyLocation.pathname.includes("/qualitychecks/")) {
        let firstOrder = orders.find(x => x.productionOrderStatus === state.RUNNING);
        if (!firstOrder) {
          firstOrder = orders.find(x => x.productionOrderStatus === state.PAUSED);
          if (!firstOrder) {
            firstOrder = orders.find(x => x.productionOrderStatus === state.PLANNED);
            if (!firstOrder) {
              firstOrder = orders.find(x => x.productionOrderStatus === state.STOPPED);
              if (!firstOrder) {
                firstOrder = orders.find(x => x.productionOrderStatus === state.DONE);
              }
            }
          }
        }

        orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING);
        var o;
        var ordersOnZones = false;
        for (o = 0; o < orders.length; o++) {
          if (orders[o].bowMetaData) {
            let metaData = JSON.parse(orders[o].bowMetaData).find(x => x.MetaDataType === 1).MetaData[0];
            if (metaData.UsedZones.length > 0 && !ordersOnZones) {
              ordersOnZones = true;
            }
          }
        }

        if (!ordersOnZones && !qualityCheckPageSwitch) {
          props.actions.setSelectedZone(null);
        }

        if (firstOrder) {
          if (ordersOnZones) {
            props.actions.setSelectedZone(zones.find(x => x.id === JSON.parse(firstOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0].UsedZones[0].ZoneId).name);

          }
          if (historyLocation.pathname.includes("/order/")) {
            history.push('/order/' + firstOrder.id + '/' + firstOrder.orderLineId);
          }
          else {
            dataService.getProductionOrderLineBOMOutProducedByBOMOutId(firstOrder.bomOut[0].id).then(bomOutProduced => {
              props.actions.setSelectedWorkstation(line);
              let progress = Math.ceil(bomOutProduced.quantityProduced / firstOrder.bomOut[0].quantityOnCarrier);
              history.push('/qualitychecks/' + progress + '/' + firstOrder.id + '/' + firstOrder.orderLineId);
            }).catch((error) => { toast.error(error, { position: "top-center" }) });

          }
        }

        if (orderId) {
          history.push('/order/' + orderId + '/' + orderLineId);
        }
      }

    }).catch((error) => { toast.error(error, { position: "top-center" }) });
  }

  var now = new Date();
  var day = now.getDate();
  var month = now.getMonth() + 1;
  var year = now.getFullYear();
  var hour = now.getHours();
  var minutes = now.getMinutes();
  var seconds = now.getSeconds();
  var zeroHours = "";
  var zeroMinutes = "";
  var zeroSeconds = "";
  var zeroDays = "";
  var zeroMonths = "";

  if (day < 10) {
    zeroDays = "0";
  }
  if (month < 10) {
    zeroMonths = "0";
  }
  if (hour < 10) {
    zeroHours = "0";
  }
  if (minutes < 10) {
    zeroMinutes = "0";
  }
  if (seconds < 10) {
    zeroSeconds = "0";
  }

  var date = zeroDays + day + "/" + zeroMonths + month + "/" + year + " " + zeroHours + hour + ":" + zeroMinutes + minutes + ":" + zeroSeconds + seconds;

  return <React.Fragment>
    <AppBar className={classes.appBar} position="fixed">
      <div className={classes.titleContainer}>
        <div className={classes.smartProduction}>
          <div className={classes.smart}>
            SMART
          </div>
          <div className={classes.production}>
            {props.nav.smart}
          </div>
        </div>
        <div className={classes.date}>
          {date}
        </div>
      </div>
      {props.nav.showActiveLines && zones !== null && zones.length > 0 ? <div className={classes.lines}>
        <div className={classes.lineText}>{props.workstation.activeWorkstations.length > 0 ? t("Line") : ""}</div>
        {props.workstation.activeWorkstations.map(x => { return (x.id === props.workstation.selectedWorkstation ? <SelectedWorkstation zones={zones} key={x.id} line={x.code} id={x.id} {...props} actions={props.actions}></SelectedWorkstation> : <button onClick={() => selectLine(x.id)} className={classes.line} key={x.id}>{x.code}</button>) })}
      </div> : <></>}
      {props.nav.showActiveRecyclingLines && props.workstation.activeRecyclingWorkstations ?
        <div className={classes.lines}>
          <div className={classes.lineText}>{props.workstation.activeRecyclingWorkstations.length > 0 ? t("Line") : ""}</div>
          {props.workstation.activeRecyclingWorkstations.map(x => { return (x.id === props.workstation.selectedRecyclingWorkstationId ? <SelectedRecyclingWorkstation key={x.id} line={x.code} id={x.id} {...props} actions={props.actions}></SelectedRecyclingWorkstation> : <button onClick={() => selectLine(x.id)} className={classes.line} key={x.id}>{x.code}</button>) })}
        </div> : <></>}
      <div className={classes.userInfoContainer}>
        <Button aria-controls="simple-menu" aria-haspopup="true" className={classes.languageButton} onClick={handleClick}>
          <User className={classes.userIcon} />
          <div className={classes.userInfo}>{props.user.userInfo ? props.user.userInfo.given_name : ""}</div>
          <div className={classes.expandArrow}>
            <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
          </div>
        </Button>
        <Menu id="simple-menu" style={{ marginTop: "20px", marginLeft: "20px" }} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          {/* <MenuItem onClick={navigateSettings}>{t('Profile')}</MenuItem> */}
          {/* <MenuItem onClick={navigateSettings}>{t('UserManagement')}</MenuItem> */}
          <MenuItem onClick={logout}>{t('Logout')}</MenuItem>
        </Menu>
      </div>
      <button className={classes.notifications} onClick={() => setNotificationDrawerOpen(true)}>
        <Bell className={classes.notificationsIcon} />
        {props.notification.counter > 0 ? <div className={classes.unread}>{props.notification.counter > 99 ? "+99" : props.notification.counter}</div> : <React.Fragment></React.Fragment>}
      </button>
    </AppBar>
    <BreakDownDetectedDialog {...props} machineDataChanged={machineDataChanged} actions={props.actions}></BreakDownDetectedDialog>
    <ReportProblemDialog dialogOpen={reportProblemDialogOpen} loading={notificationSubmissionLoading} closeDialog={() => setReportProblemDialogOpen(false)} submitProblem={submitProblemNotification} actions={props.actions}></ReportProblemDialog>
    <WorkstationNotificationsDrawer notifications={notifications} closeDrawer={() => openNotificationsDrawer(false)} openDrawer={openNotificationsDrawer} drawerOpen={notificationDrawerOpen} {...props} openReportProblemDialog={openReportProblemDialog} actions={props.actions}></WorkstationNotificationsDrawer>
  </React.Fragment>
}

const useStyles = makeStyles({

  titleContainer: {
    order: 1,
    display: 'inline-flex',
    width: "fit-content",
    height: "45px",
    marginRight: "auto",
    marginLeft: "70px",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },

  userIcon: {
    color: FlagstoneTheme.palette.text.primary,
    marginTop: "3px",
    marginRight: "5px"
  },

  userInfo: {
    fontSize: "12px",
    fontFamily: "Lato, sans-serif",
    color: "#000000",
    marginTop: "3px",
  },

  userInfoContainer: {
    order: 3,
    marginLeft: "auto",
    marginRight: "24px",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: "auto",
    height: "45px"
  },

  menuButton: {
    marginRight: '10px'
  },

  appBar: {
    backgroundColor: '#EFEFEF',
    boxShadow: "none",
    borderBottom: "1px solid #DEDEDE",
    height: "45px",
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
  },

  smart: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#4654FF",
    height: "12px",
    marginTop: "5px",
    textAlign: "left"
  },

  production: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#000000",
    height: "12px"
  },

  arrowIcon: {
    fill: FlagstoneTheme.palette.primary.main,
    width: "20px",
    height: "20px"
  },

  expandArrow: {
    marginTop: "2px",
    marginLeft: "5px"
  },

  date: {
    fontSize: "11px",
    fontFamily: "Lato, sans-serif",
    color: "#8D8D8D",
    float: "left",
    alignSelf: "center",

  },

  smartProduction: {
    float: "left",
    marginRight: "10px"
  },

  lines: {
    order: 2,
    display: "flex",
    alignItems: "center",
    textWrap: "nowrap",
  },

  lineText: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    marginRight: "10px"
  },

  line: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    backgroundColor: "transparent",
    display: "inline",
    outline: "none",
    cursor: "pointer",
    border: "none"
  },

  selectedLine: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    color: "#4654FB",
    backgroundColor: "#E6E8FE",
    display: "inline",
    outline: "none",
    border: "1px solid white",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
  },

  notifications: {
    order: 4,
    border: "none",
    outline: "none",
    cursor: "pointer",
    backgroundColor: "rgb(1,1,1,0)"
  },

  unread: {
    width: "17px",
    height: "17px",
    borderRadius: "50%",
    backgroundColor: "#D84949",
    position: "absolute",
    top: "4px",
    right: "10px",
    color: "white",
    fontSize: "10px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    paddingTop: "2px",
    boxSizing: "border-box"
  },

  notificationsIcon: {
    marginTop: '3px',
    height: "23px",
    width: "23px",
    marginRight: "10px"
  }
});

function mapStateToProps(state) {
  return {
    notification: state.notification,
    workstationState: state.workstationState,
    workstation: state.workstation,
    user: state.user,
  }
}

export default connect(mapStateToProps)(HeaderBar)
